'use strict';

angular.module('internal.investigations')
    .controller('InternalInvestigationDocument', ['$scope', '$stateParams', '$state', 'Documents', 'Upload', 'DocumentTypes', '$q', 'FileTypes',
        function ($scope, $stateParams, $state, Documents, Upload, DocumentTypes, $q, FileTypes) {
        $scope.resetInvestigation();
        $scope.investigation_document = $stateParams.investigation_document;
        $scope.investigationDocumentID = $stateParams.investigationDocumentID;
        $scope.saving = false;
        $scope.deleting = false;
        $scope.loading = true;
        $scope.types = [];
        $scope.extensions = '*';
        $scope.documentUrl = null;

        if ($stateParams.investigationDocumentID != null) {
            var a = Documents.getByID($stateParams.investigationDocumentID).then(function (document) {
                $scope.investigation_document = document;
                const baseApiLocation = apiLocation.replace(/\/$/, '');
                const documentId = encodeURIComponent($scope.investigationDocumentID);
                const documentCode = encodeURIComponent(document.code);
                $scope.documentUrl = `${baseApiLocation}/api/Core/StorageDocument/${documentId}/Download/${documentCode}`;
            })

            var b = DocumentTypes.get({ check_permission: true }).then(function (types) {
                $scope.types = types;
            })

            $q.all([a, b]).catch(function (response) {
                $scope.errorMessage = "There was a problem loading the document."
            })
            .finally(() => {
                $scope.loading = false;
            });
        }
        else {
            $scope.investigation_document = {};
            FileTypes.getByEnterprise().then(function (data) {
                if (data != null && data.length > 0) {
                    $scope.extensions = data.toString();
                } else {
                    $scope.extensions = '*';
                }
                $scope.loading = false;
            });
        }

        $scope.save = function () {
            function updateDocumentInUI(document) {
                updateArray($scope.investigation.documents, document);
                updateArray($scope.masterInvestigation.documents, document);
            }

            function updateAndRedirectToDocuments(document, stateParams = null) {
                updateDocumentInUI(document);
                $scope.saving = false;
                
                if(stateParams) {
                    $state.go('internal.licensing.investigation.documents', { id: $scope.investigationID }, stateParams);
                } else {
                    $state.go('internal.licensing.investigation.documents', { id: $scope.investigationID });
                }
            }

            function creatingDocument(documentID) {
                return documentID == null;
            };

            function saveWithStorage(document, isNew) {
                if (isNew) {
                    $scope.investigation_document.fromComplaint = true;
                    return Documents.storageUpload($scope.investigationID, $scope.investigation_document, progress => {
                        $scope.uploadMessage = `Upload progress: ${progress.percent}% (${progress.chunkIndex + 1}/${progress.totalChunks})`;
                    }).then(savedDoc => {
                        $scope.uploadMessage = "Document upload complete";
                        updateAndRedirectToDocuments(savedDoc, { reload: true });
                    });
                } else {
                    return Documents.updateDocument($scope.investigationDocumentID, document)
                        .then(savedDocument => updateAndRedirectToDocuments(savedDocument));
                }
            }

            function saveWithoutStorage(document, isNew) {
                if (isNew) {
                    document.fromComplaint = true;
                    return Documents.upload(document, $scope.investigationID)
                        .then(function (document) {
                            if (document == null) {
                                alert("Upload failed. File is too large");
                                return;
                            }

                            updateAndRedirectToDocuments(document, { reload: true });
                        });
                }

                return Documents.save(document, true, $scope.investigationID)
                    .then(function (document) { return updateAndRedirectToDocuments(document); });
            }

            $scope.saving = true;
            $scope.uploadMessage = null;
            $scope.errorMessage = null;

            const isNew = creatingDocument($scope.investigationDocumentID);

            Documents.storageAvailable()
                .then(response => {
                    const saveFn = response.documentStorageAvailable ? saveWithStorage : saveWithoutStorage;
                    return saveFn($scope.investigation_document, isNew);
                })
                .catch(response => {
                    const { errors, Message } = response;
                    let errorMessage = "Unable to upload your document";

                    if (errors && typeof errors === 'object') {
                        const firstKey = Object.keys(errors)[0];
                        errorMessage = errors[firstKey]?.[0] || Message || errorMessage;
                    } else {
                        errorMessage = Message || errorMessage;
                    }

                    $scope.errorMessage = errorMessage;
                })
                .finally(() => {
                    $scope.saving = false;
                });
        }

        $scope.delete = function () {
            $scope.deleting = true;

            Documents.delete($stateParams.investigationDocumentID).then(function () {
                updateArray($scope.investigation.documents, $scope.investigation_document, true);
                updateArray($scope.masterInvestigation.documents, $scope.investigation_document, true);
                $scope.deleting = false;
                $state.go('internal.licensing.investigation.documents', { id: $scope.investigationID });
            });
        }

        $scope.hasDocumentTypePermission = function (document) {
            var permission = false;

            if (document != null) {
                if (document.document_type_id == null) {
                    permission = true;
                }
                else {
                    $scope.types.forEach(function (type) {
                        if (type.id == document.document_type_id) {
                            permission = true;
                        }
                    })
                }
            }

            return permission;
        }
    }])
;